var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---4.0-My-Registered-Clubs---Expanded",
    transform: "translate(-338.000000, -100.000000)",
    fill: "#0375BA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/UI/Add-Copy",
    transform: "translate(338.000000, 100.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C8.27614237,-5.07265313e-17 8.5,0.223857625 8.5,0.5 L8.5,5.5 L13.5,5.5 C13.7761424,5.5 14,5.72385763 14,6 L14,8 C14,8.27614237 13.7761424,8.5 13.5,8.5 L8.5,8.5 L8.5,13.5 C8.5,13.7761424 8.27614237,14 8,14 L6,14 C5.72385763,14 5.5,13.7761424 5.5,13.5 L5.5,8.5 L0.5,8.5 C0.223857625,8.5 0,8.27614237 0,8 L0,6 C0,5.72385763 0.223857625,5.5 0.5,5.5 L5.5,5.5 L5.5,0.5 C5.5,0.223857625 5.72385763,5.07265313e-17 6,0 L8,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.8a166751aec79e680d40596244de653c.svg";
export { ForwardRef as ReactComponent };